import "babel-polyfill";
import BrowserRouter from 'react-router-dom/BrowserRouter';
import React from 'react';
import { hydrate } from 'react-dom';

import '../common/util/rootFont'
import '../common/style/App.css'

//import App from './components/router/fixIndex';
import App from './components/router/index';
import util from './util/tools';
import utilWithoutAuth from "./util/toolsWithoutAuth";
import "antd-mobile/dist/antd-mobile.css"
//首个页面为活动页面就不需要授权
if(location.pathname === "/quxiaoshuo/getMoneyNew" || location.pathname === "/quxiaoshuo/zj"){
  console.log("禁用进入时获取权限")
  utilWithoutAuth.loadFirst(renderDom,App);
}else{
  util.loadFirst(renderDom,App);
}

function renderDom(App){
  hydrate(<BrowserRouter><App /></BrowserRouter>,document.getElementById('root'));

  if (module.hot) {module.hot.accept();}
}
